import { useState } from 'react';

type Theme = 'light' | 'dark';

const KEY = 'mtg.theme';
// The browser bar color for each theme (index.html and public/theme.js set the first one).
const THEME_COLOR: Record<Theme, string> = { light: '#f9d9ec', dark: '#1a1550' };

const current = (): Theme => (document.documentElement.dataset.theme === 'dark' ? 'dark' : 'light');

/** Switches between light and dark vaporwave, remembered on this device only. */
export function ThemeToggle() {
  const [theme, setTheme] = useState<Theme>(current);

  function toggle() {
    const next: Theme = theme === 'dark' ? 'light' : 'dark';
    if (next === 'dark') document.documentElement.dataset.theme = 'dark';
    else delete document.documentElement.dataset.theme;
    document.querySelector('meta[name="theme-color"]')?.setAttribute('content', THEME_COLOR[next]);
    try {
      localStorage.setItem(KEY, next);
    } catch {
      // Not remembered this time; the theme still changes.
    }
    setTheme(next);
  }

  return (
    <button type="button" className="theme-toggle" onClick={toggle} aria-label={theme === 'dark' ? 'Switch to light mode' : 'Switch to dark mode'}>
      {theme === 'dark' ? '☀ Light' : '☾ Dark'}
    </button>
  );
}
